Namespace 'Monitoring.Models.SocialContents.LinkedIn.Serializers'

class Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInAuthorSerializer
  serialize: (linkedInAuthor) ->
    {
      id: linkedInAuthor.getId(),
      username: linkedInAuthor.getUsername(),
      name: linkedInAuthor.getName(),
      profile_picture_url: linkedInAuthor.getProfilePictureUrl()
    }

  deserialize: (json) ->
    builder = new Monitoring.Models.SocialContents.LinkedIn.Builders.LinkedInAuthorBuilder
    builder.setId(json.id)
    builder.setUsername(json.username)
    builder.setName(json.name)
    builder.setProfilePictureUrl(json.profile_picture_url)
    builder.build()
